import { put, call, take, fork } from 'redux-saga/effects'
import { acceptInvitationCollaborationService } from 'src/api/collection'

import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'
import { ACCEPT_INVITATION_COLLABORATION } from 'src/reducers/collection/type'
import { acceptInvitationCollaborationSuccess } from 'src/reducers/collection/action'
/**
 *
 * @param {*} payload
 */
function* acceptInvitationCollaborationSagaFlow(payload) {
  try {
    const { code, callback } = payload
    yield call(acceptInvitationCollaborationService, code)

    yield put(acceptInvitationCollaborationSuccess())
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* acceptInvitationCollaborationWatcher() {
  while (true) {
    const action = yield take(ACCEPT_INVITATION_COLLABORATION)
    const { payload } = action

    yield fork(generalSaga, acceptInvitationCollaborationSagaFlow, payload)
  }
}
